import { type ReactNode } from "react";
import "./section-emphasis.css";

type Mark = "circle" | "underline" | "double" | "brackets" | "highlight" | "sweep";
type Tone = "blue" | "ochre" | "sage" | "mint";

const strokes: Record<Exclude<Mark, "highlight">, string[]> = {
  circle: ["M184 12 C143 -1 51 0 17 15 C-12 28 0 59 50 64 C103 71 193 63 199 39 C202 27 196 18 184 12 Z"],
  underline: ["M5 56 C52 61 129 49 195 54"],
  double: ["M4 55 C60 48 139 51 195 52", "M22 63 C75 60 137 60 181 58"],
  brackets: ["M15 6 L3 6 L3 62 L15 62", "M185 6 L197 6 L197 62 L185 62"],
  sweep: ["M3 58 C53 66 115 59 151 54 C168 51 184 47 197 42"],
};

/** Decorations never replace or hide the semantic heading text. */
export default function SectionEmphasis({ children, mark = "underline", tone = "blue" }: {
  children: ReactNode;
  mark?: Mark;
  tone?: Tone;
}) {
  return <span className="dv-emphasis" data-mark={mark} data-tone={tone}>
    {children}
    {mark === "highlight" ? <span className="dv-emphasis-wash" aria-hidden="true" /> : (
      <svg className="dv-emphasis-drawing" viewBox="0 0 200 70" preserveAspectRatio="none" aria-hidden="true" focusable="false">
        {strokes[mark].map((d, index) => <path key={d} d={d} pathLength="1" className={index ? "dv-emphasis-follow" : undefined} />)}
      </svg>
    )}
  </span>;
}

